import layout from '@/layout'
const meta = { auth: true }

export default {
  path: '/app',
  component: layout,
  children: ((pre) => [
    {
      path: 'pad-version-management',
      name: `${pre}pad-version-management`,
      meta: {
        ...meta,
        cache: true,
        title: 'PAD应用版本管理',
        head: true,
        funcID: 'B0601',
        PID: 'B00',
      },
      component: () => import('@/views/backstage/appManager/padVersionManagement'),
    },
    {
      path: 'app-device-status',
      name: `${pre}app-device-status`,
      meta: {
        ...meta,
        cache: true,
        head: true,
        title: '设备在线监控',
        funcID: 'B0602',
        PID: 'B00',
      },
      component: () => import('@/views/backstage/appManager/appDeviceStatus/index.vue')
    },
  ])('appManager-'),
}
